import ShareForwardIcon from '@/assets/icons/Share-Forward';
import { ROUTE_DOCS_PROJECTS } from '@/common/constants';
import { format } from 'date-fns';
import { CircleArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export const createColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();

  return [
    {
      accessorKey: 'contour_number',
      header: () => t('no.'),
    },
    {
      accessorKey: 'regnum',
      header: () => t('lot.number'),
    },
    {
      accessorKey: 'area',
      header: () => t('area'),
    },
    {
      accessorKey: 'status',
      header: () => t('status'),
      cell: ({ row }: any) =>
        row?.original?.merged ? (
          <p>{t('projected')}</p>
        ) : (
          <p className="text-red-default">{t('undesigned')}</p>
        ),
    },
    {
      accessorKey: 'wgs.84',
      header: () => t('wgs.84'),
      cell: ({ row }: any) => (
        <div className="flex gap-2.5 items-center">
          <a
            href={'https://crop2.agro.uz/?land=' + row.original.id}
            target="_blank"
          >
            <ShareForwardIcon />
          </a>
        </div>
      ),
    },
    {
      accessorKey: 'created_at',
      header: () => t('date'),
      cell: ({ row }: any) => {
        const date = new Date(row.original.created_at);
        return isNaN(date.getTime()) ? '-' : format(date, 'dd.MM.yyyy');
      },
    },
    {
      id: 'actions',
      header: () => t('actions'),
      cell: ({ row }: any) => (
        <div className="flex justify-start">
          {row?.original?.merged ? (
            <CircleArrowRight
              onClick={() =>
                navigate(
                  `/${lang}/${ROUTE_DOCS_PROJECTS}/${row.original.project_id}`,
                )
              }
              className={'stroke-green-default cursor-pointer'}
            />
          ) : null}
        </div>
      ),
    },
  ];
};
